function parseStars(stars) {
  return typeof stars === 'string'
    ? parseInt(stars.trim().slice(' stars')[0])
    : stars
}

module.exports.parseStars = parseStars
